var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 131,
    viewBox: "0 0 116 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 110.058V20.377H62.7733C63.6078 20.377 64.2823 19.6853 64.2823 18.8516V4.60844C64.2823 0.138473 70.0342 -1.70625 72.6438 1.92998L112.907 58.2469V58.229C115.818 62.2908 115.818 67.7364 112.907 71.7981L72.6438 128.115C70.0342 131.751 64.2823 129.907 64.2823 125.437V111.566C64.2823 110.732 63.6078 110.058 62.7733 110.058H0Z",
    fill: "url(#paint0_linear_126_287)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2982 82.9092C34.6422 82.9092 32.2422 82.2372 30.0982 80.8932C27.9862 79.5492 26.3222 77.5972 25.1062 75.0372C23.8902 72.4452 23.2822 69.3092 23.2822 65.6292C23.2822 61.9492 23.8902 58.8292 25.1062 56.2692C26.3222 53.6772 27.9862 51.7092 30.0982 50.3652C32.2422 49.0212 34.6422 48.3492 37.2982 48.3492C39.9862 48.3492 42.3862 49.0212 44.4982 50.3652C46.6102 51.7092 48.2742 53.6772 49.4902 56.2692C50.7382 58.8292 51.3622 61.9492 51.3622 65.6292C51.3622 69.3092 50.7382 72.4452 49.4902 75.0372C48.2742 77.5972 46.6102 79.5492 44.4982 80.8932C42.3862 82.2372 39.9862 82.9092 37.2982 82.9092ZM37.2982 77.4852C38.8662 77.4852 40.2262 77.0692 41.3782 76.2372C42.5302 75.3732 43.4262 74.0612 44.0662 72.3012C44.7382 70.5412 45.0742 68.3172 45.0742 65.6292C45.0742 62.9092 44.7382 60.6852 44.0662 58.9572C43.4262 57.1972 42.5302 55.9012 41.3782 55.0692C40.2262 54.2052 38.8662 53.7732 37.2982 53.7732C35.7942 53.7732 34.4502 54.2052 33.2662 55.0692C32.1142 55.9012 31.2022 57.1972 30.5302 58.9572C29.8902 60.6852 29.5702 62.9092 29.5702 65.6292C29.5702 68.3172 29.8902 70.5412 30.5302 72.3012C31.2022 74.0612 32.1142 75.3732 33.2662 76.2372C34.4502 77.0692 35.7942 77.4852 37.2982 77.4852ZM60.9082 82.4292V51.2292L63.6442 54.0612H53.8042V48.8292H67.1482V82.4292H60.9082Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_287",
    x1: 21.4542,
    y1: 0,
    x2: 21.4542,
    y2: 130.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.ee9c1e49ff7a405a1edc0a8d408db7f9.svg";
export { ForwardRef as ReactComponent };